import axios from 'axios'
import { BUSCAR_USUARIOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarUsuariosPlataformas (pagina, registrosPorPagina, filtros) {

  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/usuarios/plataforma-web${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_USUARIOS,
        payload: response

      })
  );
}
